export default function Log({
  examinateur,
  action,
  eleve,
  horodatage,
  note,
  module,
}) {
  return (
    <div className="sm:text-lg text-base border border-black sm:px-10 px-2 py-2">
      <p>
        <span className="underline">{examinateur}</span> {action}{" "}
        <span className="underline">{eleve}</span>, {note} pour le module{" "}
        {module}.
      </p>
      <p>{horodatage}</p>
    </div>
  );
}
